/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiRole } from './InternalApiRole';
import {
    InternalApiRoleFromJSON,
    InternalApiRoleFromJSONTyped,
    InternalApiRoleToJSON,
    InternalApiRoleToJSONTyped,
} from './InternalApiRole';
import type { InternalApiAlertFilterExpression } from './InternalApiAlertFilterExpression';
import {
    InternalApiAlertFilterExpressionFromJSON,
    InternalApiAlertFilterExpressionFromJSONTyped,
    InternalApiAlertFilterExpressionToJSON,
    InternalApiAlertFilterExpressionToJSONTyped,
} from './InternalApiAlertFilterExpression';

/**
 * Set of expressions that defines alerts search filters with its metadata
 * @export
 * @interface InternalApiAlertFilter
 */
export interface InternalApiAlertFilter {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertFilter
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertFilter
     */
    name: string;
    /**
     * 
     * @type {Array<InternalApiAlertFilterExpression>}
     * @memberof InternalApiAlertFilter
     */
    expressions: Array<InternalApiAlertFilterExpression>;
    /**
     * 
     * @type {Array<InternalApiRole>}
     * @memberof InternalApiAlertFilter
     */
    roles?: Array<InternalApiRole>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiAlertFilter
     */
    inSync: boolean;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertFilter
     */
    alertCount?: number;
}

/**
 * Check if a given object implements the InternalApiAlertFilter interface.
 */
export function instanceOfInternalApiAlertFilter(value: object): value is InternalApiAlertFilter {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expressions' in value) || value['expressions'] === undefined) return false;
    if (!('inSync' in value) || value['inSync'] === undefined) return false;
    return true;
}

export function InternalApiAlertFilterFromJSON(json: any): InternalApiAlertFilter {
    return InternalApiAlertFilterFromJSONTyped(json, false);
}

export function InternalApiAlertFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'expressions': ((json['expressions'] as Array<any>).map(InternalApiAlertFilterExpressionFromJSON)),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(InternalApiRoleFromJSON)),
        'inSync': json['inSync'],
        'alertCount': json['alertCount'] == null ? undefined : json['alertCount'],
    };
}

export function InternalApiAlertFilterToJSON(json: any): InternalApiAlertFilter {
    return InternalApiAlertFilterToJSONTyped(json, false);
}

export function InternalApiAlertFilterToJSONTyped(value?: InternalApiAlertFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'expressions': ((value['expressions'] as Array<any>).map(InternalApiAlertFilterExpressionToJSON)),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(InternalApiRoleToJSON)),
        'inSync': value['inSync'],
        'alertCount': value['alertCount'],
    };
}

